<template>
  <div>
    <h4 class="mb16">客户储蓄账户信息</h4>
    <div>

      <Row class="row" :gutter="16">
        <Col span="8">开户行名称</Col>
        <Col span="8">银行账号</Col>
        <Col span="8">开户人姓名</Col>
      </Row>

      <Row class="row" :gutter="16">
        <Form :rules="formRules2" ref="countForm" :model="countParams">
          <Col span="8">
            <FormItem prop="bankName" class="notip textleft">
              <Select class="width80"
                      v-model="countParams.bankName"
                      :filterable="true"
              >
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in bankList" :value="item.bankName" :key="'keyX'+item.bankCode">{{item.bankName}}</Option>
              </Select>
              <!--                    <Input class="width80" v-model="countParams.bankName" v-if="actAddSelectBillTotal<=0"/>-->
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem prop="bankAccount" class="notip">
              <Input class="width80" v-model="countParams.bankAccount"/>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem prop="accountName" class="notip">
              <Input class="width80" v-model="countParams.accountName"/>
            </FormItem>
          </Col>
        </Form>
      </Row>
    </div>
  </div>
</template>

<script>
  // import {getBankInfo} from "../../../../../api/contractList";
  import {getbankInfo} from "../../../../../api/book";

  export default {
    name: "CountInfo",
    data(){
      return {
        bankList:[],
        countParams: {
          bankName: '',
          bankAccount: '',
          accountName: '',
          costRemark: ''
        },
        formRules2: {
          bankName: [
            {required: true, message: '', trigger: 'blur', type: 'string'}

          ],
          bankAccount: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber}
          ],
          accountName: [
            {required: true, message: '', trigger: 'blur', type: 'string'}
          ]
        },
      }
    },
    methods:{
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error(' '));
        }
        callback();
      },
      init(){
        this.countParams= {
          bankName: '',
            bankAccount: '',
            accountName: '',
            costRemark: ''
        }
        this.$refs['countForm'].resetFields()

      },
      validate(){
        let re=null
        this.$refs['countForm'].validate(bool=>{
          re=bool
        })
        return re
      }

    },
    created() {
      getbankInfo().then(res=>{
        if(res.data) {
          this.bankList = res.data
        }
      }).catch(err=>{})
    }
  }
</script>

<style scoped>
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
